import sortBy from 'lodash/sortBy';
import uniqBy from 'lodash/uniqBy';

import type { ReportDto } from '@src/api';
import type { ReportDtoDefId } from '@stores/dictionaryStores/reports/reportsStore';

type ReportWithChildrenDtoDefId = ReportDto & {
  children?: ReportWithChildrenDtoDefId[];
  key: string;
  title: string;
  count?: number;
};

// Группировка по report_group (1 уровень иерархии), по report_type (2 уровень иерархии)
export const toTreeView = (reports: ReportDtoDefId[]): ReportWithChildrenDtoDefId[] => {
  const output = sortBy(
    reports.filter((report) => report.reportGroupCode && report.reportTypeCode),
    ['reportGroupCode', 'reportTypeOrderNum', 'reportTypeCode'],
  );

  return uniqBy(output, 'reportGroupCode').map((item) => ({
    reportGroupCode: item.reportGroupCode,
    key: item.reportGroupCode ?? '',
    title: `${item.reportGroupCode ?? ''}${item.reportGroupCode && item.reportGroupName ? ' - ' : ''}${
      item.reportGroupName ?? ''
    }`,
    children:
      uniqBy(
        output.filter((el) => el.reportGroupCode === item.reportGroupCode),
        'reportTypeCode',
      )
        .map((ver) => ({
          reportGroupCode: ver.reportGroupCode,
          reportTypeCode: ver.reportTypeCode,
          key: `${ver.reportGroupCode} - ${ver.reportTypeCode}`,
          title: `${ver.reportTypeCode ?? ''}${ver.reportTypeCode && ver.reportTypeName ? ' - ' : ''}${
            ver.reportTypeName ?? ''
          }`,
          count: reports.filter(
            (report) => report.reportGroupCode === ver.reportGroupCode && report.reportTypeCode === ver.reportTypeCode,
          ).length,
        }))
        .sort((a) => {
          if (a.reportTypeCode === 'KND') return -1;
          return 0;
        }) ?? [],
  }));
};
